import { InputField, SelectField } from 'components/Inputs/Inputs'
import { Field } from 'react-final-form'
import { useTranslation } from 'react-i18next'
import closeImage from 'assets/images/close.png'

export default function TransportationVehicle(props: any): JSX.Element {
  const { t } = useTranslation()
  return (
    <div className="bg-white w-full flex flex-wrap rounded-xl relative mt-3 p-4">
      <h4 className="text-lg">{t('Vehicle Details')}</h4>
      {props.mode !== 'view' && (
        <button
          type="button"
          onClick={props.onRemove}
          className=" absolute rtl:left-2 rtl:right-auto ltr:right-2 top-2 bg-[#FCE5E5] right-2 text-red-600 text-lg w-8 h-8 text-center rounded-xl">
          <img src={closeImage} alt="close" className="m-auto" />
        </button>
      )}
      <div className="w-full flex flex-wrap mt-3">
        <div className="w-1/5 p-1">
          <Field
            label="Vehicle Type"
            name={`${props.name}.VehicleTypeId`}
            render={SelectField}
            options={props.configration?.data?.VehicleTypes || []}
            valueField="Id"
            textField="Value"
            disabled={props.mode === 'view'}
          />
        </div>
        <div className="w-1/5 p-1">
          <Field label="Brand" name={`${props.name}.Brand`} type="text" render={InputField} />
        </div>
        <div className="w-1/5 p-1">
          <Field label="Year" name={`${props.name}.Year`} type="number" render={InputField} />
        </div>
        <div className="w-1/5 p-1">
          <Field
            label="Vehicle Number"
            name={`${props.name}.VehicleNumber`}
            type="text"
            render={InputField}
          />
        </div>
      </div>
    </div>
  )
}
